const STORAGE_KEY = 'welcomeHidden';
const DISMISSAL_DURATION_MS = 20 * 60 * 1000;

function removeStoredDismissal() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Storage can be unavailable in restrictive browser modes.
  }
}

function dismissalIsActive(now = Date.now()) {
  let storedValue;

  try {
    storedValue = localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return false;
  }

  if (storedValue === null) {
    return false;
  }

  const dismissedAt = Number(storedValue);
  const validTimestamp = Number.isFinite(dismissedAt) && dismissedAt > 0 && dismissedAt <= now;

  if (!validTimestamp || now - dismissedAt >= DISMISSAL_DURATION_MS) {
    removeStoredDismissal();
    return false;
  }

  return true;
}

function storeDismissal(now = Date.now()) {
  try {
    localStorage.setItem(STORAGE_KEY, String(now));
  } catch (error) {
    // The component still hides for the current page without persistence.
  }
}

export { DISMISSAL_DURATION_MS, STORAGE_KEY, dismissalIsActive, storeDismissal };
